import React from 'react';

import { ImageProps } from 'Elements/Image';

import { List, Item, ImageIcon, StyledIcon, Text, Container } from './IconList.styled';

export interface Item {
    icon: {
        src?: ImageProps['src'];
        as?: React.ElementType;
    };
    iconColour?: string;
    children?: string | React.ReactNode;
    text?: string;
    id: string;
}

export interface Props {
    items: Item[];
}

const IconList: React.FC<Props> = props => {
    const { items } = props;

    return (
        <Container>
            <List>
                {items.map(item => (
                    <Item key={item.id}>
                        {item.icon.src && <ImageIcon src={item.icon.src} alt="" />}
                        {item.icon.as && (
                            <StyledIcon as={item.icon.as} $iconColour={item.iconColour} />
                        )}
                        <Text>
                            {item.children}
                            {item.text}
                        </Text>
                    </Item>
                ))}
            </List>
        </Container>
    );
};

export default IconList;
